<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1 pb-2">
            <div class="row">
              <!-- Título -->
              <div class="col-md-12 mb-1">
                <label>Título</label>
                <input v-model="procedure.title" class="form-control" type="text" disabled />
              </div>

              <!-- Descrição -->
              <div class="col-md-12 mb-1">
                <label>Descrição:</label>
                <ckeditor v-model="procedure.description" :config="editorConfig" :editor="editor" disabled />
              </div>

              <!-- Anexo -->
              <div v-if="procedure.file" class="col-md-12 mb-1 attached-file">
                <i class="fa fa-paperclip"></i>

                <!-- ALTERADO: antes usava storage direto, agora chama rota de download -->
                <a :href="fileDownloadUrl" target="_blank">
                  {{ procedure.file ? procedure.file.split('/').pop() : '' }}
                </a>
              </div>

              <!-- Botão voltar -->
              <div class="col-md-12 text-right">
                <hr />
                <router-link to="/procedures" class="btn btn-back mr-1">
                  <i class="fa fa-arrow-left" />
                  Voltar
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";

export default {
  data() {
    return {
      procedure: {
        title: "",
        description: "",
        file: null,
        id: null,
      },
      editor: ClassicEditor,
      editorConfig: {
        width: "800px",
        height: "400px",
      },
    };
  },

  computed: {
    // URL para download direto via controller
    fileDownloadUrl() {
      if (!this.procedure.id || !this.procedure.file) return null;
      const url = `${this.$store.state.api}procedures/${this.procedure.id}/download`;
      return url;
    },
  },

  methods: {
    getProcedure(id) {
      const api = this.$store.state.api + "procedures/" + id;

      axios
        .get(api)
        .then((response) => {
          const data = response.data.data[0];
          this.procedure = data;

        })
        .catch((error) => {
          console.error("Erro ao buscar procedimento:", error.response);
          this.$message(null, error.response?.data || "Erro ao buscar", "error");
        });
    },
  },

  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.getProcedure(id);
    }
  },
};
</script>

<style scoped>
.attached-file {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #6e6b7b;
  margin-bottom: 10px;
}

.attached-file i {
  margin-right: 6px;
}

.attached-file a {
  text-decoration: underline;
  color: #6e6b7b;
}
</style>
